import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetAllPublications,
  UpdatePublication,
  AddPublication,
  DeletePublication,
  CreateNewTenant,
  GetAvailableTenants,
  GetPublicationSrc,
  GetPublicationFillCnt
};

function DeletePublication(publicationId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/publications/${publicationId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function GetPublicationSrc(versionId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/publications/source/${versionId}`,
      headers
    )
    .then(response => {
      onSuccess(response);
    })
    .catch(error => {
      onError(error);
    });
}

function GetPublicationFillCnt(fillCnt, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/publications/fillcontent`,
      fillCnt,
      headers
    )
    .then(response => {
      onSuccess(response);
    })
    .catch(error => {
      onError(error);
    });
}

function GetAllPublications(contractNumber, versionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/publications`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetAvailableTenants(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/tenants", headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdatePublication(
  publicationId,
  updatedPublication,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/publications/${publicationId}`,
      updatedPublication,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function AddPublication(newPublication, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/publications`,
      newPublication,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function CreateNewTenant() {
  // var headers = getAuthHeader();
}
